export default __webpack_public_path__ + "static/media/dialyzer-reprocessor.dda61025.JPG";